import React from 'react';
import { Home, Grid, ShoppingCart, ListOrdered, User } from 'lucide-react';
import { useNavigation } from '../../context/NavigationContext';
import { useApp } from '../../context/AppContext';
import { Screen } from '../../types';
import { Badge } from './Badge';
export function BottomNav() {
  const {
    currentScreen,
    resetTo
  } = useNavigation();
  const {
    cart
  } = useApp();
  const navItems = [{
    screen: Screen.HOME,
    icon: Home,
    label: 'Home'
  }, {
    screen: Screen.CATEGORIES,
    icon: Grid,
    label: 'Categories'
  }, {
    screen: Screen.CART,
    icon: ShoppingCart,
    label: 'Cart',
    badge: cart.length
  }, {
    screen: Screen.ORDERS,
    icon: ListOrdered,
    label: 'Orders'
  }, {
    screen: Screen.CUSTOMER_DASHBOARD,
    icon: User,
    label: 'Account'
  }];
  return <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-6 py-3 pb-safe z-50" data-id="element-93">
      <div className="flex justify-between items-center max-w-md mx-auto" data-id="element-94">
        {navItems.map(item => {
        const isActive = currentScreen === item.screen || item.screen === Screen.CUSTOMER_DASHBOARD && currentScreen === Screen.PROFILE;
        const Icon = item.icon;
        return <button key={item.label} onClick={() => resetTo(item.screen)} className="flex flex-col items-center justify-center gap-1 min-w-[60px]" data-id="element-95">
              <div className={`p-1.5 rounded-xl transition-colors ${isActive ? 'text-primary' : 'text-gray-400'}`} data-id="element-96">
                {item.badge !== undefined ? <Badge count={item.badge} data-id="element-97">
                    <Icon className="w-6 h-6" strokeWidth={isActive ? 2.5 : 2} data-id="element-98" />
                  </Badge> : <Icon className="w-6 h-6" strokeWidth={isActive ? 2.5 : 2} data-id="element-99" />}
              </div>
              <span className={`text-[10px] font-medium transition-colors ${isActive ? 'text-primary' : 'text-gray-500'}`} data-id="element-100">
                {item.label}
              </span>
            </button>;
      })}
      </div>
    </div>;
}